import { render, staticRenderFns } from "./Zona.vue?vue&type=template&id=7173d923"
import script from "./Zona.vue?vue&type=script&lang=js"
export * from "./Zona.vue?vue&type=script&lang=js"
import style0 from "./Zona.vue?vue&type=style&index=0&id=7173d923&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports